// imports
import merge from 'lodash/merge';
import DEFAULT_CONFIG from 'minsky-kit/js/Config';
import {defaultTranslations, defaultApps} from 'minsky-kit/js/utils/orejime';

export default merge(DEFAULT_CONFIG, {
    globals: GLOBALS, // passed by compiler

    app: {
        readyMessage: [
            '%cMade with %c♥ %cby %cwww.minsky.be',

            'font-weight: normal; font-size: 12px; font-family: Poppins, Helvetica',
            'color: red; font-weight: bold; font-size: 14px',
            'font-weight: normal; font-size: 12px; font-family: Poppins, Helvetica',
            'font-weight: bold; font-size: 12px; font-family: Poppins, Helvetica',
        ],
    },

    mqManager: {
        debounce: 250,

        queries: [
            { name: 'ready',            query: '(min-width: 0em)' },
            { name: 'mobileNavInit',    query: '(max-width: 72em)' },
            { name: 'mobileNavDestroy', query: '(min-width: 72em)' },
        ],
    },

    svgSprites: [
        `/themes/custom/${GLOBALS.theme}/assets/sprite.svg`,
    ],

    cookieConsent: {
        active:        true,
        loggedInUsers: false,

        // You must provide a link to your privacy policy page
        // privacyPolicy: '/privacy-policy',

        // Optional. Set Orejime in debug mode to have a few stuff
        // logged in the console, like warning about missing translations.
        // defaults to false
        debug: false,

        // You can overwrite existing translations and add translations for your
        // app descriptions and purposes. See `src/translations.yml` for a full
        // list of translations that can be overwritten
        translations: defaultTranslations(),

        // The list of third-party apps that Orejime will manage for you.
        // The apps will appear in the modal in the same order as defined here.
        apps: defaultApps(),

        // categories: [{
        //     name: "functional",
        //     title: "Functional",
        //     apps: [
        //         "functional-cookies"
        //     ]
        // }]
    }
});
